<template>
    <wysiwyg-editor :id="question.label" v-model="value" class="col-12 p-0" />
</template>

<script>
import WysiwygEditor from '@/components/elements/WysiwygEditor';

export default {
    components: {
        WysiwygEditor
    },

    props: {
        question: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            value: ''
        };
    },

    watch: {
        value(value) {
            this.$emit('input', value);
        }
    },

    created() {
        this.value = this.question.answer;
    }
};
</script>
